export default __webpack_public_path__ + "static/media/Utsav_Resume.971e49cb.pdf";